import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	operatorLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	operatorLabel: {
		id: 'jql-builder-basic.common.picker-trigger.trigger-operator.operator-label',
		defaultMessage: 'Operator dropdown',
		description:
			'Label for select dropdown to choose a jql operator, which is used by Screen Reader Users',
	},
});

export default messages;
